import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --border-properties: 1px solid #cccccc;
    }

    .visually-hidden {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    .direct-product-layout {
      display: grid;
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    /* "Solutions" is a section heading, but it sits above a narrow phone
       list where the full 16px h3 default is too heavy, so mobile drops to
       the label-small tier. Desktop returns to the title scale at 600px. */
    h3 {
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .products-list {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .header {
      display: flex;
      flex-direction: column;
    }

    .no-results-message {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      grid-column: 2 / 8;
      grid-row: 3;
    }

    form {
      position: relative;
    }

    form > input {
      height: calc(40rem / var(--default-rem-px-count));
      text-indent: calc(10rem / var(--default-rem-px-count));
    }

    form > svg {
      position: absolute;
      top: calc(12rem / var(--default-rem-px-count));
      right: calc(12rem / var(--default-rem-px-count));
      height: calc(20rem / var(--default-rem-px-count));
      width: calc(20rem / var(--default-rem-px-count));
    }

    .products-list {
      display: grid;
      grid-template-columns: repeat(1, minmax(0, 1fr));
      margin-top: calc(60rem / var(--default-rem-px-count));
    }

    .product-wrapper {
      padding: calc(30rem / var(--default-rem-px-count));
    }

    direct-product-index-card {
      border-bottom: var(--border-properties);
    }

    .product-details {
      cursor: pointer;
      display: flex;
      flex-direction: column;
    }

    .product-details img {
      max-width: 100%;
      height: calc(300rem / var(--default-rem-px-count));
      margin: 0 auto;
    }

    .product-sku {
      padding-top: calc(10rem / var(--default-rem-px-count));
    }

    .product-header {
      .header {
        padding: calc(20rem / var(--default-rem-px-count)) 0;
        font-weight: 500;
      }
      .subheader {
        font-size: var(--fs-body-small);
        line-height: var(--lh-body-small);
        letter-spacing: var(--ls-body-small);
      }
    }

    .optional-details,
    .order-ctas {
      padding-top: calc(20rem / var(--default-rem-px-count));
    }

    .optional-row-header {
      font-weight: 500;
    }

    .order-ctas,
    .optional-row-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    .optional-row-wrapper {
      font-size: var(--fs-body-small);
      letter-spacing: var(--ls-body-small);
    }

    .optional-row-wrapper:not(:last-child) {
      padding-bottom: calc(12rem / var(--default-rem-px-count));
    }

    .order-ctas input,
    .optional-row-header {
      width: calc(40% - 15px);
    }

    .order-ctas cta-button,
    .optional-row-value {
      width: calc(60% - 15px);
    }

    /* Override browser defaults */
    input {
      -webkit-appearance: none;
      outline: none;
      box-shadow: none;
      border: none;
      padding: 0;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type='number'] {
      -moz-appearance: textfield;
    }

    input {
      border: 1px solid;
      display: block;
      padding-left: calc(12rem / var(--default-rem-px-count));
    }

    #search-input {
      width: calc(200rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      .direct-product-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      h3 {
        font-size: var(--fs-title);
        line-height: var(--lh-title);
        letter-spacing: var(--ls-title);
      }

      .header {
        grid-column: 2 / 14;
        grid-row: 2;
      }

      .products-list {
        grid-column: 2 / 14;
        grid-row: 3;
      }

      .no-results-message {
        grid-column: 2 / 14;
        grid-row: 2;
      }

      .header {
        flex-direction: row;
        justify-content: space-between;
        min-height: calc(48rem / var(--default-rem-px-count));
      }

      .products-list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        align-items: stretch;
      }

      direct-product-index-card {
        border-right: var(--border-properties);
      }

      direct-product-index-card:nth-child(2n) {
        border-right: none;
      }

      direct-product-index-card:nth-child(n + 1):nth-last-child(-n + 2) {
        border-bottom: none;
      }
    }

    @media (min-width: 1000px) {
      .products-list {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }

      direct-product-index-card:nth-child(2n) {
        border-right: var(--border-properties);
      }

      direct-product-index-card:nth-child(3n) {
        border-right: none;
      }

      direct-product-index-card:nth-child(n + 1):nth-last-child(-n + 3) {
        border-bottom: none;
      }
    }

    @media (min-width: 1440px) {
      .products-list {
        grid-template-columns: repeat(4, minmax(0, 1fr));
      }

      direct-product-index-card:nth-child(3n) {
        border-right: var(--border-properties);
      }

      direct-product-index-card:nth-child(4n) {
        border-right: none;
      }

      direct-product-index-card:nth-child(n + 1):nth-last-child(-n + 4) {
        border-bottom: none;
      }
    }
  `,
];
